'use strict';
var _ = require('underscore');
var ROOT_CLASS_NAME = 'sw-swiper';
var defaultOptions = {
  //setWrapperSize: true,
  slideToClickedSlide: true,
  slidesPerView: 'auto',
  autoHeight: true,

  noSwipingClass: ROOT_CLASS_NAME + '--no-swiping',
  slideClass: ROOT_CLASS_NAME + '__slide',
  slideActiveClass: ROOT_CLASS_NAME + '--active',
  slideVisibleClass: ROOT_CLASS_NAME + '--visible',
  slideDuplicateClass: ROOT_CLASS_NAME + '__duplicate',
  slideNextClass: ROOT_CLASS_NAME + '--next',
  slidePrevClass: ROOT_CLASS_NAME + '--prev',
  wrapperClass: ROOT_CLASS_NAME + '__wrapper',
  bulletClass: ROOT_CLASS_NAME + '__pagination-bullet',
  bulletActiveClass: ROOT_CLASS_NAME + '__pagination-bullet--active',
  paginationHiddenClass: ROOT_CLASS_NAME + '--pagination-hidden',
  paginationCurrentClas: ROOT_CLASS_NAME + '--pagination-current',
  paginationTotalClass: ROOT_CLASS_NAME + '__pagination-total',
  paginationProgressbarClass: ROOT_CLASS_NAME + '__pagination-progressbar',
  buttonDisabledClass: ROOT_CLASS_NAME + '__button--disabled'
};

module.exports =  function ($) {

  $.fn.swSwiper = function (options) {
    var $els = $(this);
    var dfd = $.Deferred();

    require(['swiper'], function (Swiper) {
      $els.each(function (index, el) {
        if(!el.swiper) {
          new Swiper(el, _.extend(options || {}, defaultOptions));
        }
        return dfd.resolve(el);
      });
    });

    return dfd.promise();
  };

};
